var _defs, _path, _path2, _use, _use2, _use3, _use4, _use5, _path3, _g, _path4, _path5, _path6, _path7, _path8, _path9, _use6, _use7, _use8, _use9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _use10, _path17, _path18, _path19, _path20, _path21, _use11, _path22, _path23, _path24, _path25, _path26, _path27, _g2, _g3, _g4, _g5, _use12, _use13, _use14, _use15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 600 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v75h350v75h-50zm300 0H150v200H0v-50z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h300v150H0z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h600v300H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "#002b7f",
    d: "M600 260.881c-6.723 4.045-12.499 13.498-30.36 13.498-35.711 0-44.641-19.902-71.427-19.902-17.856 0-26.785 19.902-44.641 19.902-35.715 0-44.643-19.902-71.429-19.902-17.857 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.429-19.902-17.858 0-26.786 19.902-44.643 19.902-35.714 0-44.643-19.902-71.428-19.902-17.858 0-23.215 14.182-33.929 14.182v25.621c10.714 0 16.071-14.181 33.929-14.181 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.715 19.901 71.429 19.901 17.857 0 26.785-19.901 44.643-19.901 26.785 0 35.714 19.901 71.428 19.901 17.857 0 26.786-19.901 44.643-19.901 26.786 0 35.714 19.901 71.429 19.901 17.856 0 26.785-19.901 44.641-19.901 26.786 0 35.716 19.901 71.427 19.901 17.861 0 23.637-5.64 30.36-9.684v-29.435z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -49.753)"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -99.507)"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -149.26)"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -199.014)"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(0 -248.768)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h300v152H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 0h300v150H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 30,
    d: "m0 0 300 150m0-150L0 150"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cf142b",
    strokeWidth: 20,
    d: "m0 0 300 150m0-150L0 150",
    clipPath: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 50,
    d: "M150 0v200M0 75h350"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#cf142b",
    strokeWidth: 30,
    d: "M150 0v200M0 75h350"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M814.961-301.181 797.244 407.48c0 37.298 80.097 37.298 88.583 0L868.11-301.181h-53.149z",
    style: {
      fill: "#a24300",
      strokeWidth: 6.935,
      stroke: "#fff"
    },
    transform: "matrix(.12095 0 0 .28726 347.839 166.046)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.43857 0 0 .37683 122.2 25.058)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.31451 .10485 -.1383 -.30323 1046.472 373.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m496.063 549.213 17.717 70.866 35.433-53.15-17.717 88.583 35.433-35.433-35.433 88.582 35.433-35.433-35.433 88.583 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-88.583 35.433 35.433-35.433-88.582 35.433 35.433-17.717-88.583 35.433 53.15 17.717-70.866z",
    style: {
      fill: "#006d00",
      strokeWidth: 8.25,
      stroke: "#fff"
    },
    transform: "translate(177.166 -224.052)"
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M673.228 325.161v496.067M602.362 644.058l70.866 106.3 70.866-106.3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m602.362 573.192 70.866 106.3 70.866-106.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m602.362 502.326 70.866 106.3 70.866-106.3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m602.362 449.176 70.866 88.583 70.866-88.583"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m602.362 396.027 70.866 88.582 70.866-88.582"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m620.079 342.877 53.15 106.3 53.15-106.3"
  })))), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(.23652 -.28186 .29496 .22762 354.567 204.654)"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(.15164 .33524 -.3329 .1673 907.539 -153.47)"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(-.20952 .30246 -.3147 -.19945 1141.363 167.58)"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "matrix(-.20772 -.25838 .23618 -.23515 689.986 567.277)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.36218 -.09947 -.2098 .31773 1222.415 -24.23)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e",
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m460.63 549.213 28.643 70.866 42.223-53.15-10.184 88.583 27.9-35.433-17.716 88.582 25.249-35.433-25.249 88.583 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299 35.433-35.433-35.433 106.299-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-35.433-106.299 35.433 35.433-45.617-88.583 45.617 35.433-53.15-88.582 42.966 35.433-25.25-88.583 35.433 53.15.001-70.866z",
    style: {
      fill: "#006d00",
      strokeWidth: 8.25,
      stroke: "#fff"
    },
    transform: "translate(283.465 -124.016)"
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m750.673 460.63 28.855 124.016v336.618"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m719.695 761.81 59.833 88.583 60.682-88.582"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m717.998 690.945 61.53 88.582 60.682-88.582"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m718.846 620.079 60.682 88.582 59.833-88.582"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m716.3 566.929 63.228 70.866 53.149-70.866"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m708.662 513.78 70.866 70.865 45.406-70.865"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m719.589 469.222 53.15 86.886 35.327-95.478"
  })))), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    transform: "matrix(.36088 .10411 .01321 .38053 452.761 -239.266)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "none",
      strokeWidth: 1,
      stroke: "#000"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "m354.331 531.496 88.583 88.583 17.716-53.149v88.582l35.433-35.433-17.716 88.583 35.432-35.434-17.716 88.584 35.433-35.433-17.716 106.299 35.433-35.433-35.433 106.299 35.433-35.433-17.717 106.298-17.716 53.151-17.717 17.72-17.717-17.72-17.716-53.151-53.15-82.294 35.434 11.429-35.433-106.299 35.433 35.433-53.15-106.299 35.433 35.433-53.15-88.584 53.15 35.434-70.866-88.583 53.149 35.433-70.866-70.866 70.866 35.433-53.149-88.583z",
    style: {
      fill: "#006d00",
      strokeWidth: 8.25,
      stroke: "#fff"
    },
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m378.962 560.015 63.952 95.497 17.716 53.15 8.859 45.205 8.858 78.811 9.315 70.866 8.401 141.736",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m425.197 903.544 63.665 70.866 50.749-88.583",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m417.082 814.961 70.579 88.583 50.75-88.583",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m407.48 752.443 70.867 80.235 45.948-88.583M372.047 637.796l88.583 70.866 25.831-70.866",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m360.618 602.363 82.296 53.149 10.515-53.149M389.764 690.945l81.095 70.866 33.946-70.866",
    transform: "matrix(.04613 -.36474 .32602 .0648 386.005 315.21)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m52.504 257.674 98.536-17.68 102.642 17.68-47.626 19.801-87.861 1.415-65.691-21.216z",
    style: {
      fill: "#9d9d9d",
      strokeWidth: 1.008,
      stroke: "#000"
    },
    transform: "matrix(.25333 0 0 .25333 412 157.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.789 98.445c-17.223 5.987-36.302-8.425-67.359 15.094 0 0-54.144-23.163-58.257 30.371-.165 2.167 8.57 15.223 9.786 14.29 6.804-5.224-3.23 5.072-3.23 6.56 0 1.5.998 2.333 1.335 2.994.331.667 1.163 1.665 1.329 4.494.165 2.828-6.137 10.544-3.474 13.372 2.657 2.829 2.822 10.984 2.822 13.311 0 2.326 1.666 8.816 2.829 10.151 1.163 1.328 3.159 4.653 3.159 7.481 0 2.829 1.163 10.647.661 12.637-.496 1.996 2.994 4.494 6.16 5.492 3.159.998 43.935 1.706 101.162.708 57.233-.998 76.328 8.057 99.974-.543 3.655-1.328 4.322-4.322 3.992-5.988-.337-1.659 0-6.979.998-8.314.998-1.328 7.653-11.975 6.318-13.971 1.256-1.134 10.589 5.39 4.645-.436-1.524-1.493.853-17.216 1.673-20.528.827-3.318 2.096-9.549 3.621-10.706 1.532-1.157-2.598-5.488-2.305-6.27.298-.788 1.411-3.229 2.962-4.341 0 0 2.885-13.527 1.106-20.176-1.767-6.655-8.27-36.583-48.862-30.588 0 0-54.34-20.9-71.045-15.094z",
    style: {
      fill: "#c00",
      strokeWidth: 1.629,
      stroke: "#000"
    },
    transform: "matrix(.25333 0 0 .25333 412 157.18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27506 0 0 .27506 413.752 163.796)"
  }, /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.241,
    transform: "matrix(.49697 -.0446 .08947 .72677 44.7 100.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.75.125c-5.093.89-15.156 29.245-12.609 38.75 1.763 6.58 4.498 11.12 6.047 13.906-3.405-4.685-11.383-13.75-22.25-13.75-13.664 0-15.431 29.948-15.094 31.875.001.007-.002.026 0 .032.001.004.029.027.031.031h.031c.613-.715 6.142-13.094 19.657-13.094 8.896 0 15.829 7.035 18.375 10.031-.001.945.022 1.858.031 2.782-2.004 2.828-3.282 9.531-9.469 17.968C27.023 98.852 4.128 99.897.281 100h49.532c.047 0 .109.003.156 0 .022.002.04-.001.062 0 .047.003.109 0 .157 0h49.531c-3.847-.103-27.18-1.148-34.656-11.344-6.188-8.437-7.028-15.14-9.032-17.968.009-.924.032-1.837.032-2.782 2.545-2.996 9.478-10.031 18.375-10.031 13.514 0 19.043 12.379 19.656 13.094h.031c.002-.004.03-.027.031-.031.002-.006-.001-.025 0-.032.337-1.927-1.43-31.875-15.093-31.875-10.868 0-18.846 9.065-22.25 13.75 1.548-2.786 4.29-8.575 5.718-13.906C65.118 29.219 55.091.132 50 .125c-.08 0-.169-.014-.25 0zm-6.437 52.844c.352.49.662.912.906 1.281.005.008.541 2.977.547 2.984-.003.064 2.627 10.186 2.624 10.25-.264-.392-3.737-13.915-4.077-14.515zm13.375 0c-.341.6-4.033 14.123-4.297 14.515-.003-.064 3.393-13.139 3.39-13.203 0-.01-.437 2.964-.437 2.953.244-.369.991-3.775 1.344-4.265z",
    style: {
      fill: "#f7d917",
      strokeWidth: 1.241,
      stroke: "#000"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 67.578s4-1.859 8-1.859 8 1.859 8 1.859v4.953s-4-1.859-8-1.859-8 1.859-8 1.859v-4.953z",
    style: {
      fill: "#f7d917",
      strokeWidth: 1.241,
      stroke: "#000"
    }
  }))), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "matrix(.49538 .0597 -.0636 .7295 168.919 96.59)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f7d917",
      strokeWidth: 0.715,
      stroke: "#000"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m24.308 134.56 9.69-11.814s.903 1.168 0 0C14.132 97.065 13.127 82.331 15.363 74.87c2.236-7.461 6.709-15.544 18.635-25.493 11.926-9.948 20.156-4.419 31.336-4.419 11.181 0 14.163 2.487 23.852 3.731 9.69 1.243 35.778 2.487 35.778 2.487v-6.84s1.029.192 0 0c-11.518-2.147-26.088 0-35.778-2.487-9.689-2.487-17.889-3.108-28.324-3.108-10.435 0-17.92-3.043-24.628 1.31-6.709 4.352-14.908 11.813-20.871 18.031C9.4 64.3 6.419 76.735 7.164 84.818c.746 8.083 3.727 14.923 8.199 21.14 4.473 6.218 3.727 11.192 5.218 15.544 1.491 4.353 3.727 13.679 3.727 13.058zM239.255 134.56l-9.69-11.814s-.904 1.168 0 0c19.865-25.681 20.87-40.415 18.634-47.876-2.236-7.461-6.708-15.544-18.634-25.493-11.926-9.948-20.156-4.419-31.337-4.419-11.181 0-14.162 2.487-23.852 3.731-9.69 1.243-35.778 2.487-35.778 2.487v-6.84s-1.029.192 0 0c11.519-2.147 26.088 0 35.778-2.487 9.69-2.487 17.889-3.108 28.324-3.108 10.436 0 17.92-3.043 24.629 1.31 6.708 4.352 14.907 11.813 20.87 18.031 5.963 6.218 8.945 18.653 8.199 26.736-.745 8.083-3.727 14.923-8.199 21.14-4.472 6.218-3.727 11.192-5.217 15.544-1.491 4.353-3.727 13.679-3.727 13.058z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.553 38.701h34.563v70.894h-34.563z",
    style: {
      strokeWidth: 0.835
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f7d917",
      strokeWidth: 0.5,
      stroke: "#000"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M119.684-23.799s3.72 3.028 6.575 6.922c2.856 3.893 4.846 8.652 4.846 8.652s-4.759-1.99-8.652-4.846c-3.894-2.855-6.922-6.575-6.922-6.575V6.656s3.028-3.72 6.922-6.575c3.893-2.856 8.652-4.846 8.652-4.846s-1.534 3.927-2.524 8.653c-.891 4.25-8.183 14.064-8.183 14.064l21.303 1.429s-3.542-11.243-4.969-15.493c-1.536-4.578-2.167-8.653-2.167-8.653s4.759 1.99 8.653 4.846c3.893 2.855 6.921 6.575 6.921 6.575v-26.302s-3.028 3.72-6.921 6.575c-3.894 2.856-8.653 4.846-8.653 4.846s1.99-4.759 4.846-8.652c2.855-3.894 6.575-6.922 6.575-6.922h-26.302z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M149.978 23.076a17.143 17.143 0 1 1-34.286 0 17.143 17.143 0 1 1 34.286 0z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M116.074 25.535h34.102s.494-6.596-1.974-9.064h-10.594l-.179-9.888h-10.042l-.179 9.888s-7.127.357-10.41.357c-1.489 4.041-1.26 4.381-1.26 4.381l.536 4.326z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "#f7d917",
      strokeWidth: 0.75,
      stroke: "#000"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M110.877 107.221s6.212 5.056 10.979 11.557c4.767 6.501 8.09 14.446 8.09 14.446s-7.946-3.323-14.446-8.09c-6.501-4.767-11.557-10.979-11.557-10.979v43.916s5.056-6.211 11.557-10.979c6.5-4.767 14.446-8.09 14.446-8.09s-3.323 7.946-8.09 14.447c-4.767 6.5-10.979 11.557-10.979 11.557h43.916s-6.212-5.057-10.979-11.557c-4.767-6.501-8.09-14.447-8.09-14.447s7.946 3.323 14.446 8.09c6.501 4.768 11.557 10.979 11.557 10.979v-43.916s-5.056 6.212-11.557 10.979c-6.5 4.767-14.446 8.09-14.446 8.09s3.323-7.945 8.09-14.446c4.767-6.501 10.979-11.557 10.979-11.557h-43.916zM27.24 181.78l21.625-3.813s-6.995-3.901-12.819-9.475c-5.824-5.574-10.476-12.822-10.476-12.822s8.402 1.892 15.632 5.458c7.23 3.566 13.288 8.806 13.288 8.806l-7.626-43.249s-3.901 6.995-9.475 12.819c-5.574 5.824-12.822 10.475-12.822 10.475s1.892-8.401 5.458-15.631c3.566-7.23 8.806-13.288 8.806-13.288l-21.625 3.813L27.24 181.78zM226.839 121.06s5.24 6.058 8.806 13.288c3.566 7.23 5.458 15.631 5.458 15.631s-7.248-4.651-12.822-10.475c-5.574-5.824-9.475-12.819-9.475-12.819l-7.626 43.249s6.058-5.24 13.288-8.806c7.23-3.566 15.632-5.458 15.632-5.458s-4.652 7.248-10.476 12.822c-5.823 5.574-12.819 9.475-12.819 9.475l21.625 3.813 10.034-56.907-21.625-3.813z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m27.464 179.533.15 31.506s52.648-17.928 105.296-17.928 105.296 17.928 105.296 17.928v-31.506s-52.685-17.929-105.371-17.929c-52.686 0-105.371 17.929-105.371 17.929z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.66123 0 0 .66123 21.246 -360.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "M2.02 723.052a12.122 12.122 0 1 1-24.243 0 12.122 12.122 0 1 1 24.243 0z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 10.965 -378.602)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 8.822 -400.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 15.25 -420.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 28.822 -436.459)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 47.394 -447.887)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 68.108 -446.459)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 88.822 -443.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 109.537 -440.887)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 242.316 -360.32)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 252.597 -378.602)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 254.74 -400.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 248.312 -420.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 234.74 -436.459)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 216.169 -447.887)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 195.454 -446.459)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 174.74 -443.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(-.66123 0 0 .66123 154.026 -440.887)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.04)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -378.32)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -392.602)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -404.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -414.459)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -447.887)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -446.459)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -439.03)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "matrix(.66123 0 0 .66123 138.474 -428.887)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.457 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M143.571 136.291a10.357 10.357 0 1 1-20.714 0 10.357 10.357 0 1 1 20.714 0z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "translate(-108.714 16.786)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "translate(107.286 16.786)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M134.791 210.096h34.762v15.153h-34.762z",
    style: {
      fill: "#002b7f",
      strokeWidth: 0.841,
      stroke: "#000"
    },
    transform: "matrix(.25333 0 0 .25333 412 157.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.043 233.111a22.995 8.556 0 1 1-45.99 0 22.995 8.556 0 1 1 45.99 0z",
    style: {
      fill: "#3e8225",
      strokeWidth: 1.5,
      stroke: "#000"
    },
    transform: "matrix(-.1718 -.01744 .00604 .24262 461.52 156.97)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.937 229.285-8.709 8.709 10.101 5.832 23.493-6.294-4.187-13.304-20.698 5.057zM267.406 229.285l8.71 8.709-10.102 5.832-23.493-6.294 4.187-13.304 20.698 5.057z",
    style: {
      fill: "#c00",
      strokeWidth: 1.086,
      stroke: "#000"
    },
    transform: "matrix(.25333 0 0 .25333 412 157.18)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.043 233.111a22.995 8.556 0 1 1-45.99 0 22.995 8.556 0 1 1 45.99 0z",
    style: {
      fill: "#3e8225",
      strokeWidth: 1.5,
      stroke: "#000"
    },
    transform: "matrix(.1718 -.01744 -.00604 .24262 439.58 156.97)"
  }), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    transform: "matrix(.25333 0 0 .25333 412 157.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.07 -3.476)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "M126.203 214.704a4.278 4.278 0 1 1-8.556 0 4.278 4.278 0 1 1 8.556 0z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "translate(2.406 10.16)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "translate(-52.406 6.15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "translate(-47.059 18.984)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "matrix(-1 0 0 1 303.075 -3.476)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "matrix(-1 0 0 1 301.738 10.16)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "matrix(-1 0 0 1 356.55 6.15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "matrix(-1 0 0 1 351.203 18.984)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M238.538 280.603c3.267-.567 22.977-5.253 27.127-7.76-2.678-4.828-7.484-8.605-3.744-7.018 2.014.855 3.607-5.799-2.239-10.885-16.973 5.567-57.68 15.739-108.829 15.739-52.344 0-93.562-10.707-110.535-16.273-5.846 5.086-4.025 10.864-4.378 13.023-.003.017.003 2.725 1.069 4.879 5.754 6.251 24.394 9.332 27.662 9.9 15.352 2.666 30.705 6.697 86.148 6.697 51.289 0 72.366-5.635 87.719-8.302z",
    style: {
      fill: "#fff",
      strokeWidth: 1.714,
      stroke: "#000"
    },
    transform: "matrix(.25333 0 0 .25333 412 157.18)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.27506 0 0 .27506 391.394 139.673)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.906 289.655c-3.009.523-22.147 7.301-25.968 9.61.003.014-.003.045 0 .061.325 1.988-3.322 11.251 2.062 15.935 15.632-5.127 59.525-20.406 106.634-20.406 48.209 0 88.14 15.279 103.772 20.406 5.384-4.684 1.737-13.947 2.063-15.935.003-.016-.004-.047 0-.061-3.822-2.309-22.96-9.087-25.969-9.61-14.14-2.455-28.772-11.586-79.835-11.586-47.237 0-68.619 9.131-82.759 11.586z",
    style: {
      fill: "#fff",
      strokeWidth: 1.578,
      stroke: "#000"
    }
  }), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.38439 -.14324 .15642 1.26776 -86.626 -64.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "k",
    fill: "#000",
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.864 150.9) scale(.4996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "j",
    d: "M115.508 301.56a1.872 1.872 0 1 1-3.743 0 1.872 1.872 0 1 1 3.743 0z"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "translate(55.527 153.307) scale(.4996)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "translate(57.398 154.911) scale(.4996)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.518 303.669 8.526-3.166-4.185 2.392 2.686-.083-2.492 1.168 4.001.275-8.536-.586z"
  })))), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "matrix(1.38439 -.14324 .15642 1.26776 -45.032 -76.658)"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "matrix(1.37843 .19234 -.15163 1.26835 100.17 -120.86)"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "matrix(1.38439 .14324 .15642 -1.26776 54.434 659.458)"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "matrix(1.38439 .14324 .15642 -1.26776 96.412 670.42)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIo);
export default __webpack_public_path__ + "static/media/io.d8f363d0d0aad8281dbb45e9e18e7071.svg";
export { ForwardRef as ReactComponent };